import React from 'react';
import PaymentSuccess from './PaymentSuccess';

/**
 * Payment Failure Page
 * Renders the PaymentSuccess component with failed/rejected status
 */
function PaymentFailure({ onBackToLoans, token }) {
    return <PaymentSuccess onBackToLoans={onBackToLoans} forcedStatus="rejected" token={token} />;
}

export default PaymentFailure;
